module.exports = __webpack_public_path__ + "static/media/013-The Cambie.96a2b8f4.png";